// src/components/pages/mypage/hooks/useConfirmModal.js

import { useState, useCallback } from 'react';

export default function useConfirmModal(t) {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState('');
  const [confirmAction, setConfirmAction] = useState(null);

  const handleConfirm = useCallback((action) => {
    setConfirmMessage(action.message);
    setConfirmAction(() => action.callback);
    setShowConfirmModal(true);
  }, []);

  const executeConfirmAction = useCallback(() => {
    if (confirmAction) {
      confirmAction();
    }
    setShowConfirmModal(false);
    setConfirmMessage('');
    setConfirmAction(null);
  }, [confirmAction]);

  const cancelConfirmAction = useCallback(() => {
    setShowConfirmModal(false);
    setConfirmMessage('');
    setConfirmAction(null);
  }, []);

  return {
    showConfirmModal,
    confirmMessage,
    confirmAction,
    handleConfirm,
    executeConfirmAction,
    cancelConfirmAction,
  };
}